const colors = {
  alert: '#DD533C',
  azureBlue: '#3686F0',
  jungleGreen: '#107969',
  orchid: '#C866EA',
  bluewood: '#2F3850',
  linkWater: '#E9F1FB',
  grey: '#9AA1B6',
  lightGrey: '#D6D7DC',
  zirkon: '#F8FBFF',
  white: '#FFFFFF',
  smokeWhite: '#EFEFEF',
  catskillWhite: '#E2EEF1',
  azure: '#0086F8',
  tangerine: '#FFA16C',
  golden: '#FFCF5B',
  pink: '#FF7691',
  vividPink: '#FF5FC0',
  blueHaze: '#CED3E4',
  greyishBlue: '#B0BAC9',
  black: '#0E0E0E',
  black20: '#CFCFCF',
  black60: '#6E6E6E',
  blackCoral: '#596073',
  flamingo: '#EF462F',
  botticelli: '#D5DEEA',
  heather: '#BDC7D6',
  pistachio: '#8CBD00',
  burntSienna: '#F0684A',
  casper: '#ABBBD1',
  surfieGreen: '#107969',
  selago: '#E3EEFB',
  electricViolet: '#B302FF',
  coral: '#FF7F50',
  mystic: '#D7DEE9',
  jungleGreenLighter: '#23B7A0',
  buddhaGold: '#C2B200',
  navyBlue: '#000080',
  brightNavyBlue: '#2273DD',
  olive: '#808000',
  waterloo: '#828896',
  brightGreen: '#54F200',
  lavender: '#DFEBFC',
  aqua: '#00FFF7',
  manatee: '#8C94A6',
  orangePeel: '#FB9B0A',
  heliotrope: '#D27EF0',
  heliotrope2: '#C766EA',
  amethyst: '#A667C4',
  mauve: '#E2B1F4',
  orangeRed: '#ED722E',
  yellowRed: '#FFC062',
  turquoiseGreen: '#92D9B7',
  emerald: '#5ECC8A',
  blueEyes: '#9CD0F8',
  tuftsBlue: '#4092DD',
  mauvelous: '#E992A7',
  amaranth: '#D83450',
  sonicSilver: '#6B707C',
  vermilion: '#D2371D',
  aliceBlue: '#F9FBFF',
  aliceBlueSaturated: '#F1F7FF',
  hawkesBlue: '#F1F4F9',
  lightBlue: '#F4F8FF',
  electricPurple: '#B727EA',
  purplePlum: '#AC43D1',
  periwinkleGray: '#B3C1E1',
  perwinkleCrayola: '#C0CFE3',
  solitude: '#E6EDFD',
  red: '#BE4745',
  red5: '#FCF6F6',
  blue: '#3F88C5',
  blue5: '#F5F9FC',
  green: '#2A9D8F',
  green10: '#EAF5F4',
  orange: '#EB7900',
  orange5: '#FEF8F2',
  whiteLilac: '#F6F8FC',
  jungleGreen50: '#80b4AE',
  periwinkleGray50: '#D9E0F0',
  supernova: '#FFC50D',
  mischka: '#DDE0E6',
  gainsbro: '#DADADA',
  ghost: '#CCD1D9',
  babyBlue: '#D2E0F1',
  asparagus: '#6B9E59',
  pictonBlue: '#3686F0',
  coolGrey: '#8B92A1',
  lightStealBlue: '#B3C1E1',
  beauBlue: '#CFDDEF',
  lightDivider: '#EAF1FA',
  cinnabar: '#DD533C',
  cadetBlueCrayola: '#B3BAC7',
  linkWaterDark: '#DEE7F6',
  azureishWhite: '#D4DFF7',
  stormGrey: '#707688',
  logan: '#9BA1B4',
  chardonnay: '#FFC179',
  slateGray: '#6D7485',
  titanWhite: '#E9E5FF',
  kleinBlue: '#5339F0',
  grandis: '#FFCC69',
  rawUmber: '#44580C',
  snow: '#FFF0F0',
};

const themeColors = {
  primary: colors.jungleGreen,
  secondary: colors.electricPurple,
  text: colors.bluewood,
  highlight: colors.linkWater,
  success: colors.jungleGreen,
  warning: colors.vermilion,
  comment: colors.sonicSilver,
  alert: colors.cinnabar,
  sessionBackground: colors.white,
};

export { colors, themeColors };
